function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center, Flex, Heading, HStack, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useRef } from 'react';
import SongRequestPanel from '../landing/SongRequestPanel';
import ChatFilterPanel from '../landing/ChatFilterPanel';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookAtlas, faCloudBolt, faCode, faGifts } from '@fortawesome/free-solid-svg-icons';
import ContainerStack from '../landing/ContainerStack';
import InfiniteCarousel from './InfiniteCarousel';
import { motion } from 'framer-motion';
import styles from './FeatureSection.module.css';
import TwitchBrand from '../icons/brands/Twitch';
import TrovoBrand from '../icons/brands/Trovo';
import NoiceBrand from '../icons/brands/Noice';
import YoutubeBrand from '../icons/brands/Youtube';
import SoopBrand from '../icons/brands/Soop';
import PanelHoverWrapper from './PanelHoverWrapper';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
function BrandCarousel(props) {
    var ref = useRef(null);
    return /*#__PURE__*/ _jsxs(InfiniteCarousel, _object_spread_props(_object_spread({
        color: "textPrimary",
        width: "100%",
        duration: 100,
        ref: ref
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 0.5
                },
                children: /*#__PURE__*/ _jsx(TwitchBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 0.6
                },
                children: /*#__PURE__*/ _jsx(TrovoBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 0.7
                },
                children: /*#__PURE__*/ _jsx(NoiceBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 0.8
                },
                children: /*#__PURE__*/ _jsx(YoutubeBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 0.9
                },
                children: /*#__PURE__*/ _jsx(SoopBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 1
                },
                children: /*#__PURE__*/ _jsx(TwitchBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 1.1
                },
                children: /*#__PURE__*/ _jsx(TrovoBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 1.2
                },
                children: /*#__PURE__*/ _jsx(NoiceBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 1.3
                },
                children: /*#__PURE__*/ _jsx(YoutubeBrand, {
                    className: styles.brandLogo
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                className: styles.brandLogoContainer,
                initial: {
                    opacity: 0,
                    y: -20
                },
                whileInView: {
                    y: 0,
                    opacity: 1
                },
                viewport: {
                    once: true
                },
                transition: {
                    delay: 1.4
                },
                children: /*#__PURE__*/ _jsx(SoopBrand, {
                    className: styles.brandLogo
                })
            })
        ]
    }));
}
function FeaturePanel(_param) {
    var heading = _param.heading, description = _param.description, element = _param.element, props = _object_without_properties(_param, [
        "heading",
        "description",
        "element"
    ]);
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        borderWidth: 1,
        bgGradient: "linear(to-tl, whiteAlpha.50, transparent)",
        borderColor: "borderTertiary",
        padding: {
            base: 6,
            xl: 12
        },
        spacing: 12,
        height: "100%",
        borderRadius: "lg",
        backdropFilter: "blur(8px)"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Center, {
                children: element
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                marginTop: "auto",
                spacing: 1,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "md",
                        color: "textPrimary",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSize: "md",
                        color: "textSecondary",
                        children: description
                    })
                ]
            })
        ]
    }));
}
function SmallPanel(param) {
    var icon = param.icon, title = param.title, description = param.description;
    return /*#__PURE__*/ _jsxs(Stack, {
        children: [
            /*#__PURE__*/ _jsxs(HStack, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        as: FontAwesomeIcon,
                        icon: icon,
                        size: "lg",
                        color: "textPrimary"
                    }),
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        color: "textPrimary",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "md",
                color: "textSecondary",
                children: description
            })
        ]
    });
}
function FeaturePanels(props) {
    var intl = useIntl();
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        backgroundColor: "backgroundPrimary",
        borderTopWidth: 1,
        borderColor: "borderTertiary",
        bgGradient: "radial(ellipse at center bottom, greenAlpha.300, primaryAlpha.50 60%)"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(ContainerStack, {
                paddingX: {
                    base: 8,
                    lg: 32
                },
                paddingY: 32,
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 16,
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            gap: 16,
                            flexDirection: {
                                base: 'column',
                                md: 'row'
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    flex: 1,
                                    children: /*#__PURE__*/ _jsx(PanelHoverWrapper, {
                                        onClick: function() {
                                            return navigate(WebRoutes.MODERATION);
                                        },
                                        children: /*#__PURE__*/ _jsx(FeaturePanel, {
                                            element: /*#__PURE__*/ _jsx(ChatFilterPanel, {
                                                width: "100%",
                                                maxWidth: "320px",
                                                color: "textPrimary",
                                                bgColor: "whiteAlpha.50"
                                            }),
                                            heading: intl.formatMessage({
                                                id: "flxcMd",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Auto Moderation"
                                                    }
                                                ]
                                            }),
                                            description: intl.formatMessage({
                                                id: "2ywgY0",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Remove many kinds of spam automatically with advanced chat filters, and keep your chat clean and safe."
                                                    }
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    flex: 1,
                                    children: /*#__PURE__*/ _jsx(PanelHoverWrapper, {
                                        onClick: function() {
                                            return navigate(WebRoutes.SONG_REQUESTS);
                                        },
                                        children: /*#__PURE__*/ _jsx(FeaturePanel, {
                                            overflow: "hidden",
                                            element: /*#__PURE__*/ _jsx(SongRequestPanel, {
                                                width: "100%",
                                                maxWidth: "300px",
                                                color: "textPrimary"
                                            }),
                                            heading: intl.formatMessage({
                                                id: "Bj94i2",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Built for everyone"
                                                    }
                                                ]
                                            }),
                                            description: intl.formatMessage({
                                                id: "R0/2Ce",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "The perfect blend of both user-friendly design and power-user capability to meet your needs as you build an audience."
                                                    }
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            width: "100%",
                            height: "1px",
                            bgGradient: "linear(to-r, transparent, borderSecondary, transparent)"
                        }),
                        /*#__PURE__*/ _jsxs(SimpleGrid, {
                            minChildWidth: "140px",
                            spacing: 12,
                            children: [
                                /*#__PURE__*/ _jsx(SmallPanel, {
                                    icon: faCloudBolt,
                                    title: intl.formatMessage({
                                        id: "8lC6C0",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Cloud Hosted"
                                            }
                                        ]
                                    }),
                                    description: intl.formatMessage({
                                        id: "MoX4QE",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "No downloads, no servers, and no worries. Nightbot is hosted for you, so it's always online and ready to go."
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SmallPanel, {
                                    icon: faGifts,
                                    title: intl.formatMessage({
                                        id: "mdbhLe",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Giveaways"
                                            }
                                        ]
                                    }),
                                    description: intl.formatMessage({
                                        id: "agyg81",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Easily create and customize giveaways that viewers can enter into from chat."
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SmallPanel, {
                                    icon: faCode,
                                    title: intl.formatMessage({
                                        id: "MFRAAA",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Extensible"
                                            }
                                        ]
                                    }),
                                    description: intl.formatMessage({
                                        id: "IA0Lg8",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Create powerful commands and customizations using built-in variables, regular expressions, custom code, and the API."
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SmallPanel, {
                                    icon: faBookAtlas,
                                    title: intl.formatMessage({
                                        id: "yLJ9bf",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Chat Logs"
                                            }
                                        ]
                                    }),
                                    description: intl.formatMessage({
                                        id: "naRdsB",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Find out why a message was recently deleted or a user was recently banned with fully-searchable chat logs."
                                            }
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(ContainerStack, {
                display: {
                    base: 'none',
                    lg: 'block'
                },
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        color: "textSecondary",
                        textAlign: "center",
                        paddingY: 8,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "i5cLhC",
                            defaultMessage: "Works on the most popular live streaming platforms"
                        })
                    }),
                    /*#__PURE__*/ _jsx(BrandCarousel, {
                        backgroundColor: "whiteAlpha.50",
                        paddingY: 6,
                        borderTopWidth: 1,
                        borderColor: "borderTertiary"
                    })
                ]
            })
        ]
    }));
}
export default FeaturePanels;
